/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


	$(document).ready(function() {		
		istanbul.init();
	});

	var istanbul = {
        istanbulTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {			
			this.window_resize();
			this.bxslider();	
			this.meanmenu();
			this.sticky_nav();	
			this.animated_menu();
			this.cart_toggle();
			this.sidebar_toggle();
          	this.grid_height();
            this.newsletter();
			this.product_slider();
            this.qty();
          	
          	this.fancybox_popup();   
          	
            this.sticky();
            this.wishlist();
            this.alert_css();
            this.pre_loader();
            this.scrolltop();
            this.search_toggle();
            this.section_script();
		},
      
        section_script: function(){
          var sections = new theme.Sections();
          sections.register('slideshow-section', istanbul.slider);
          sections.register('collections-list-section', istanbul.collection_list);
          sections.register('collection-section',istanbul.collectionSidebar);
          sections.register('product-template', istanbul.product);
          sections.register('latest-blog', istanbul.grid_height);
          sections.register('contact-map',istanbul.map);
          
        },
		
     map: function(container){
        
       var $container = this.$container = $(container);  
           var zoom_level = $container.attr('data-zoom_level');
           var scrollwheel = $container.attr('data-scrollwheel');

           if(scrollwheel == 'false'){

             var boolen_scroll = 0 ;

           }else{

             var boolen_scroll = 1 ;

           }

             var latlng = new google.maps.LatLng(0, 0);
            var myOptions = {
              zoom: parseInt(zoom_level),
              center: latlng,
              styles: [{"featureType":"administrative","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"simplified"}]},{"featureType":"road","stylers":[{"visibility":"simplified"}]},{"featureType":"water","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"visibility":"off"}]},{"featureType":"road.local","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","stylers":[{"color":"#84afa3"},{"lightness":52}]},{"stylers":[{"saturation":-77}]},{"featureType":"road"}],    
              scrollwheel:boolen_scroll,
              scaleControl:boolen_scroll,
              disableDefaultUI: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map2 = new google.maps.Map(document.getElementById("map-canvas"), myOptions);

            var geocoder_map2 = new google.maps.Geocoder();
            var address = $container.attr('data-address');
            geocoder_map2.geocode( { 'address': address}, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                map2.setCenter(results[0].geometry.location);

                var marker = new google.maps.Marker({
                  map: map2, 
                  position: map2.getCenter()
                });

                var contentString = $container.attr('data-address');
                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });



              } else {
                alert("Geocode was not successful for the following reason: " + status);
              }
            });
  
      },
      
      
        pre_loader : function(){

          $(window).on('load', function() { // makes sure the whole site is loaded 
            $('#status').fadeOut(); // will first fade out the loading animation 
            $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
            $('body').delay(350).css({'overflow':'visible'});
             if($(window).width() > 1024){
           		 new WOW().init();
             }
          }) 

        },
        
      product: function(container){
        var $container = this.$container = $(container);
        var sectionId = $container.attr('data-section-id');
       //======================  PRODUCT VARIANT SELECTCALLBACK
       if (!$('#ProductJson-' + sectionId).html()) {
         return;
       }
       var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
       new Shopify.OptionSelectors('productSelect', {
         product: productSingleObject,
         onVariantSelected: selectCallback,
         enableHistoryState: true
       });

       var option_name = productSingleObject.options[0];


       // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
       if (productSingleObject.options.length == 1 && productSingleObject.options[0] != 'Title') {
         $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">'+ option_name +'</label>');
       }

       // Hide selectors if we only have 1 variant and its title contains 'Default'.
       if (productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.toLowerCase().indexOf('default') !== -1) {
         $('.selector-wrapper').hide();
       }

        jQuery(function() {
          jQuery('.swatch :radio').change(function() {
            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
            var optionValue = jQuery(this).val();
            jQuery(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
          });
        });
       $('.swatch').each(function() {
         var index = $(this).data('option-index');
         $('.selector-wrapper:eq('+index+')').hide();
       });
         
        setTimeout(function(){
         $("#AddToCart").click(function(e){
               	var form = $(this).closest('form');
          		istanbul.quickviewAjaxAddToCart(form);
               	e.preventDefault();
             });
          }, 3000);
         
         //==========================   PRODUCT DETAILS SLIDER
			var proslider = $('.product_slider').bxSlider({
			  controls: true,
			  pager:true,
              infiniteLoop: false,
              mode: 'fade',
              onSliderLoad: function() {},
              onSlideBefore: function() {},
              onSlideAfter: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
                  var window_width = $( window ).width();
                  if(window_width > 1024){
                    if($('.product_slider').length > 0){
                      $('.main_pro_info .product_slider > li img').eq(currentSlideHtmlObject).elevateZoom({constrainType:"height", constrainSize:274, zoomType: "lens", containLensZoom: true, cursor: 'pointer',divId: "zoomDivPro"}); 
                    }
                  }
              },
			});
          if($container.attr('data-tab') == 'true'){
          // product description script 
  			  istanbul.tabs();
          }
        istanbul.grid_height();
          
          
      	  istanbul.zoom();
        
      },
      
      window_resize: function(){
			$(window).load(function(){
				istanbul.resizeContent();   
                istanbul.owl_carousel();
			});
          
          	$(window).resize(function() {
              istanbul.resizeContent();
              istanbul.owl_carousel();
            });
            $(window).on("orientationchange",function(){
              istanbul.resizeContent();
              istanbul.owl_carousel();
            });
		},
		
		resizeContent: function(){
			height_screen = $(window).height();
			$('#banner_slider ul li , #banner_slider .bx-viewport').height(height_screen);
			var insta_screen_height = $('#instagram .insta_img').height();
			$('.insta_title').height(insta_screen_height);
			$('.banner_error, #page_error').height(height_screen);
          
          	header_height = $('#header').height();
            menu_height = height_screen - header_height;
            $('.mean-container .mean-bar .mean-nav').css({"overflow-y": "scroll", "max-height": menu_height});
		},
	
		//================ BXSLIDER	
      	slider:function(container){
          
          var $container = this.$container = $(container);
    	  var id = $container.attr('data-section-id');
          var transition = $container.attr('data-transition');
          if($container.attr('data-autoplay') == 'true'){
            var autoplay = true;
          }
          else{
            var autoplay = false;
          }
            
          var speed = $container.attr('data-speed');
          
          if($container.attr('data-show-dots') == 'true'){
            var show_dots = true;
          }
          else{
            var show_dots = false;
          }
          if($container.attr('data-show-nav') == 'true'){
            var show_nav = true;
          }
          else{
            var show_nav = false;
          }
          
          
          //=============== SLIDER    =======          
          $('.'+ id).find('.bxslider').bxSlider({
            mode: $container.attr('data-transition'),
            captions: true,
            auto:autoplay,
            controls: show_nav,
            pager: show_dots,
            pause: $container.attr('data-speed'),
            infiniteLoop: true,
            onSliderLoad: function() {
               $('.'+ id).find('.bxslider > li').not('.bxslider > li.bx-clone').eq(0).addClass('active');
            },
            onSlideBefore: function() {},
            onSlideAfter: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
              $('.'+ id).find('.bxslider > li.active').removeClass('active');
              $('.'+ id).find('.bxslider > li').not('.bxslider > li.bx-clone').eq(currentSlideHtmlObject).addClass('active');
			}
            
          });
          
          istanbul.resizeContent();
        },
      
		bxslider: function(){	
                     
			//==========================   testimonials SLIDER
			$('.testimonials ul').bxSlider({
			  controls: true,
			  pager:true,
              mode: 'fade',
			});
                   
		},
		
		//================ RESPONSIVE MENU TRIGGER 
		meanmenu: function(){
			 jQuery('header #main-nav').meanmenu();
            $("a.meanmenu-reveal").click(function(){
              $('body').toggleClass("main_overflow");
            });
		},
		
		// ================================== FOR STICKY NAV
		sticky_nav: function(){
			if (jQuery(window).width() <= 1024) {
				var s = $("#header");
				var pos = s.position();                    
				$(window).scroll(function() {
					var windowpos = $(window).scrollTop();
					if (windowpos >= pos.top) {
						$('#header').addClass('sticky_nav');
					} else {
						 $('#header').removeClass('sticky_nav')
					}
				});	
			}	

			// ==================  Search hover	
			$('.search-form').mouseleave(function(e) {
				var get_search_length = $('#q').val().length;
				if(get_search_length > 0){
					$('input',this).css('width','400px');
					$('input',this).css('padding','15px 35px 15px 15px');
					$('.submit_icon',this).css('opacity','1');
				}
				else{
					$('input',this).attr('style','');
					$('.submit_icon',this).attr('style','');
					$('.search-form input').blur(function(e) {
						$(this).attr('style','');
						$(this).attr('style','');
					});
				}
			});
          $('.search-form').click(function(e){
            e.stopPropagation();
          });
          $('html').click(function(){
             $('.search-form input').attr('style','');
             $('.search-form .submit_icon').attr('style','');
          });
          	
		},
		
		//==========================   ANIMATED MENU 
		animated_menu: function(){
			var mainnav = $('#main-nav');
			$(".menu_toggle").click(function(e) {
				e.preventDefault();
				(this.classList.contains("active") === true) ? this.classList.remove("active") : this.classList.add("active");
				if (mainnav.hasClass('open')){
					mainnav.removeClass('open');
				}
				else{
					mainnav.addClass('open');
				}
			});
		},
			
      
        search_toggle: function(){
          $(".header_part .touch_search").click(function(e) {
            e.preventDefault();
            $('.search_toggle').slideToggle(600);				
          });

          $('html').click(function() {
            $('.search_toggle').slideUp();
          });

          $('.search_toggle,.header_part .touch_search').click(function(event){
            event.stopPropagation();
          });
        },
		//==========================   CART TOGGLE 

		cart_toggle: function(){
          	width_screen = $(window).width(); 
  			if(width_screen > 767){ 
              $(".header_part .site-header__cart-toggle").click(function(e) {
                  e.preventDefault();
                  $('.header_part.cart_box').toggleClass('chage_icon');
                  $('#CartDrawer').slideToggle(600);				
              });

              $('html').click(function() {
                  $('#CartDrawer').slideUp();
                  $('.header_part.cart_box').removeClass('chage_icon');
              });

              $('#CartDrawer,.site-header__cart-toggle').click(function(event){
                  event.stopPropagation();
              });
            }
		},
				
		//==========================   SIDEBAR TOGGLE 		
		sidebar_toggle: function(){
			$(".filter_toggle .small_filter").click(function(e) {
				$('.filter_sidebar').addClass('side_toggle');
				$('body').addClass('bodu_blur');
			});
			$(".back_arrow").click(function(e) {
				$('.filter_sidebar').removeClass('side_toggle');
				$('body').removeClass('bodu_blur');
			});			
		},
        
      collection_list: function(){
        $('.recm_product').owlCarousel({
				loop:true,
				nav:true,
				responsive:{
					0:{
						items:1
					},
					767:{
						items:1
					},
					768:{
						items:2,
						margin:30
					},
					1024:{
						items:2,
						margin:30
					},
					1025:{
						items:1
					}
				}
			});
      },
		
		//==========================   RECOMMENDED  PRODUCT			
		owl_carousel: function(){
             
          	
            var window_width = $( window ).width();
  			if(window_width <= 1024){
			
						
			$('.seller_slider, .Related_slider,.collections_list .product_list').owlCarousel({
				loop:false,
				nav:true,
				margin:10,
				responsive:{
					0:{
						items:1
					},
					480:{
						items:1
					},
					481:{
						items:2
					},
					650:{
						items:2
					},
					651:{
						items:3
					},
					768:{
						items:3,
						margin:10
					},
					1024:{
						items:4,
						margin:10
					},
					1200:{
						items:4,
					},
					1201:{
						items:5,
						loop:false,
						nav:false,
						dots:false
					}
				}
			});
           }
		},
				
      	grid_height: function(){	
           //============================== PRODUCT LIST IMG HEIGHT                     
          $('.product_item .product_img > ul').responsiveEqualHeightGrid();
          $('.product_item .product_info').responsiveEqualHeightGrid();
          $('.blog_item .blog_img').responsiveEqualHeightGrid();
          $('.blog_item .blog_info').responsiveEqualHeightGrid();
		}, 
      
        newsletter: function() {
          //===   NEASLETTER POPUP
          $(window).load(function(){
            setTimeout( function() {
              var check_cookie = $.cookie('mailing_list_popup');

              $('.newsletter_popup .close_btn').click(function(e) {
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_overlay").removeClass('newsletter_popupactive');
                $('body').removeClass('overflow_hidden');
              });

              if(check_cookie == null){
                $.cookie('mailing_list_popup', '1', { expires: 31 });
                $(".newsletter_overlay").addClass('newsletter_popupactive');
                $('body').addClass('overflow_hidden');
              }
              else if(check_cookie < 1){
                x = $.cookie('mailing_list_popup');
                y = 1;
                var z = +x + +y;
                $.cookie('mailing_list_popup', z, { expires: 31 });
                $(".newsletter_overlay").addClass('newsletter_popupactive');
                $('body').addClass('overflow_hidden');
              }
            }, 3000);
          }); 
        },
		//==========================   IMAGE SLIDER IN PRODUCT LISTING.			
		product_slider:function(){
            $('.next').click(function(e) {
				var current_pro = $(this).parents('.product_item').find('ul li.active');
				var current_index = current_pro.index();
				var last_index = $(this).parents('.product_item').find('ul li:last-child').index();
				
				if(current_index < last_index){
					current_pro.next().addClass('active');
					current_pro.removeClass('active');
				}
				else{
					$(this).parents('.product_item').find('ul li:first-child').addClass('active');
					current_pro.removeClass('active');
				}				
			});
			
			$('.prv').click(function(e) {
				var current_pro = $(this).parents('.product_item').find('ul li.active');
				var current_index = current_pro.index();
				
				if(current_index == 0){
					$(this).parents('.product_item').find('ul li:last-child').addClass('active');
					current_pro.removeClass('active');
				}
				else{
					current_pro.prev().addClass('active');
					current_pro.removeClass('active');
				}
			});
			
			$('.product_pager ul li').click(function(e) {
				e.preventDefault();
				var current_index = $(this).index();
				$(this).siblings().removeClass('active');
				$(this).addClass('active');
				$(this).parents('.product_item').find('.product_img > ul li').siblings().removeClass('active');
				$(this).parents('.product_item').find('.product_img > ul li').eq(current_index).addClass('active');
			});
		},

      	qty:function() {
          //on cart page
            $("body").on('click', '.plus', function() {			
				var getval = $(this).prev().val();
				getval++;
				$(this).prev().val(getval);
				$("#update-cart").trigger('click');
			});
          	$("body").on('click', '.minus', function() {
				var getval = $(this).next().val();
				if(getval > 1){
					getval--;
					$(this).next().val(getval);
					$("#update-cart").trigger('click');
				}
			});
        },     
      
        fancybox_popup: function(){
          $('.product-modal').fancybox({
            afterLoad: function() {
              setTimeout(function(){
                $.fancybox.update();
              },1000);
            }
          });
        },
      
      	quickview:function() {          
            //==========================   PRODUCT DETAILS SLIDER
            $('.product_slider_quick').bxSlider({
              controls: true,
              pager:true,
              infiniteLoop: false,
              mode: 'fade',
              onSliderLoad: function() {},
              onSlideBefore: function() {},
              onSlideAfter: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
                  var window_width = $( window ).width();
                  if(window_width > 1024){
                    if($('.quick_product_view .product_slider_quick').length > 0){
                      	$('.quick_product_view .product_slider_quick > li img').eq(currentSlideHtmlObject).elevateZoom({constrainType:"height", constrainSize:274, zoomType: "lens", containLensZoom: true, cursor: 'pointer',divId: "zoomDivProQuick"}); 
                    }
                  }
              },
            });

          	istanbul.wishlist();
          
            
            $(".quick_view_add").click(function(e){
               	var form = $(this).closest('form');
          		istanbul.quickviewAjaxAddToCart(form);
               	e.preventDefault();
             });
            
          
          	//zoom on featured image
            
              var window_width = $( window ).width();
              if(window_width > 1024){
                $(".quick_product_view li:visible img").elevateZoom({constrainType:"height", constrainSize:274, zoomType: "lens",containLensZoom: true, cursor: 'pointer',divId: "zoomDivProQuick"});   
              }  
            
        },
      	
      	quickviewAjaxAddToCart:function(form){
          	 $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: jQuery(form).serialize(),
                dataType: 'json',
               	beforeSend: function() {
                  $(form).find("#AddToCart").val("Wait..");
                },
                success: function(msg) { 
                  
                    $(form).find("#AddToCart").val("Thank You!!");
        
                    window.setTimeout(function() {
                      $(form).find("#AddToCart").val("ORDER NOW");
                    }, 3000);
                 	istanbul.quickviewUpdateCart();
                },
                error: function(xhr, text) {
                    $(form).find("#AddToCart").val("ORDER NOW");
                  	var data = eval('(' + xhr.responseText + ')');
                     
                    $('.product_info #AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');
                     window.setTimeout(function() {
                        $(".errors.qty-error").fadeOut();
                      }, 2000);
                }
            });
        },
                    
        quickviewUpdateCart:function(){
          	jQuery.getJSON('/cart.js', function (cart, textStatus) {
                $("#CartCount").show(); 
              	$("#CartCount").html(cart.item_count).removeClass('hidden-count');
            });          	
        },
          
        zoom:function() {
          
          if($(".product_slider li").length > 0){
            var window_width = $( window ).width();
  			if(window_width > 1024){				
              	$(".product_slider li:visible img").elevateZoom({constrainType:"height", constrainSize:274, zoomType: "lens", containLensZoom: true, cursor: 'pointer',divId: "zoomDivPro"});   
            }  
          }
          
        },
      
		//==========================   PRODUCT DETAILS DESCRIPTION		
		tabs:function(){
		 $( "#description" ).tabs();
		},
		
		sticky:function(){
			var s = $("#header");
			var pos = s.position();                    
			$(window).scroll(function() {
				var windowpos = $(window).scrollTop();
				if (windowpos > pos.top) {
					$('#header').addClass('sticky_nav');
				} else {
					 $('#header').removeClass('sticky_nav')
				}
			});	
		},
      
      	wishlist:function(){
          $(".wishlist_btn.add_wishlist").click(function(e) {
            e.preventDefault();

            var form = $(this).parent();
            $.ajax({
              url : '/contact#contact_form',
              type: "POST",
              data : form.serializeArray(),
              success:function(data, textStatus) {              
                alert("This product Added in your Wishlist"); 
                var product =form.find(".wishlist").html();
                if(product) {
                	form.parent().empty().html('<a href="/pages/wish-list" class="wishlist btn--light-secondary">Added to wishlist</a>');
            	}
            	else {
            		form.parent().empty().html('<form><a href="/pages/wish-list" class="wishlist_btn"></a></form>');
            	}
              },
              error: function() {
                $(this).append("<p>I'm afraid that didn't work.</p>");
              }
            });
          });
        },

        alert_css: function(){
          //------ alert css -----------
			window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
        },

      	
        collectionSidebar:function(){
          istanbul.sidebarParams(); 
          if ($(".filter_sidebar").length > 0) {        	                                   
            istanbul.sidebarMapClear();
            istanbul.sidebarMapClearAll();
          }
          istanbul.sidebarMapPaging();
          istanbul.sidebarMapEvents();
        },

        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },

        sidebarMapTagEvents: function() {            
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function(e) {
                var currentTags = [];
                var check_radio =  $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if(check_radio == "radio"){                 
                //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val();                
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);                    
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                istanbul.sidebarAjaxClick();
                e.preventDefault();
            });
        },

        sidebarMapCategories: function() {
            $(".categories_view .sidebar-links a").click(function(e) {           	
                if (!$(this).hasClass('active')) {                	
                    delete Shopify.queryParams.q;
                    istanbul.sidebarAjaxClick($(this).attr('href'));

                    //activate selected category
                    $(".sidebar-links a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },

        sidebarMapSorting: function(e) {  
          $("#heapbox_SortBy .heapOptions a").click(function(){           
             Shopify.queryParams.sort_by = $(this).attr("rel"); 
             istanbul.sidebarAjaxClick();
          });                 
        },

        sidebarMapEvents: function() {
            istanbul.sidebarMapTagEvents();
           	istanbul.sidebarMapCategories();
            istanbul.sidebarMapSorting();
        },

        sidebarMapPaging: function() {
            $(".collection-filter .pagination a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if(page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = istanbul.sidebarCreateUrl();
                        istanbul.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        istanbul.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
        },

        sidebarMapClearAll: function() {
            //clear all selection
             $('a.clear_all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;                
              	istanbul.sidebarAjaxClick();
                e.preventDefault();                
            });
        },

        sidebarMapClear: function() {            
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if(sidebarTag.find("input:checked").length > 0) {
                    $('.back_clear').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display","block").click(function(e) {
                        var currentTags = [];
                        if(Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if(tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if(currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        istanbul.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },

        sidebarCreateUrl: function(baseLink) {        	
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }else{
            	if (newQuery != "")
	              return location.pathname + "?" + newQuery;
	            else
	              return location.pathname + newQuery;
            }
            //return location.pathname + "?" + newQuery;
        },

        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = istanbul.sidebarCreateUrl(baseLink);  
            istanbul.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            istanbul.sidebarGetContent(newurl);            
        },
      	
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    istanbul.showLoading();
                },
                success: function(data) {
                    istanbul.sidebarMapData(data);
                    istanbul.sidebarMapPaging();
                  	if ($(".filter_sidebar").length > 0) {    
                    istanbul.sidebarMapTagEvents();
                    istanbul.sidebarMapCategories();
                    istanbul.sidebarMapClear();
                    istanbul.sidebarMapClearAll();
                    }
                    istanbul.product_slider();
                    setTimeout(function() {                      
                  		istanbul.grid_height();
                    }, 1000);
                  	istanbul.wishlist();
                    istanbul.hideLoading();   
                },
                error: function(xhr, text) {
                    istanbul.hideLoading();
                    //$('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    //istanbul.showModal('.ajax-error-modal');
                }
            });
        },
      
		showLoading: function() {
            $('.loading-modal').show();
        },
      
      	hideLoading: function() {
            $('.loading-modal').hide();
        },

          scrolltop :function(){
            $('#scrollToTop').bind("click", function () {
              $('html, body').animate({ scrollTop: 0 }, 800);
              return false;
            });
          },

        sidebarMapData: function(data) { 
          //console.log(data);
            var currentList = $(".product_list > .all_list");
            if (currentList.length == 0) {
                currentList = $(".product_list > .all_list");
            }

            var productList = $(data).find(".product_list > .all_list");
            if (productList.length == 0) {
                productList = $(data).find(".product_list > .all_list");
            }
            currentList.replaceWith(productList);
           
            //replace paging 
            if ($(data).find(".pagination").length > 0) {
            	$(".pagination").show();
                $(".collection-filter").replaceWith($(data).find(".collection-filter"));
            }else{
            	$(".pagination").hide();
            }

            //replace tags            
            $(".filter_sidebar").replaceWith($(data).find(".filter_sidebar"));       
			
          	//replace showing product
            if ($(data).find(".product_resul").length > 0) {
            	$(".product_resul").show();
                $(".product_resul").replaceWith($(data).find(".product_resul"));
            }else{
            	$(".product_resul").hide();
            }          
          	
          	//replace Collection banner
          	$(".banner_caption").closest("#page_banner").replaceWith($(data).find(".banner_caption").closest("#page_banner")); 	
          
            //for mobail remove blur
            $('body').removeClass('bodu_blur');

            $(".back_arrow").click(function(e) {
				$('.filter_sidebar').removeClass('side_toggle');
				$('body').removeClass('bodu_blur');
			});	
        },
        recently_viewed: function() {
          	$('.Recently_slider').owlCarousel({
              loop:true,
              nav:true,
              margin:10,
              responsive:{
                0:{
                  items:1
                },
                480:{
                  items:1
                },
                481:{
                  items:2
                },
                650:{
                  items:2
                },
                651:{
                  items:3
                },
                768:{
                  items:3,
                  margin:10
                },
                1024:{
                  items:4,
                  margin:10
                },
                1200:{
                  items:4,
                },
                1201:{
                  items:5,
                  loop:false,
                  nav:false,
                  dots:false
                }
              }
            });
  
            $('.next.nxt').click(function(e) {
                  var current_pro = $(this).parents('.product_item').find('ul li.active');
                  var current_index = current_pro.index();
                  var last_index = $(this).parents('.product_item').find('ul li:last-child').index();

                  if(current_index < last_index){
                    current_pro.next().addClass('active');
                    current_pro.removeClass('active');
                  }
                  else{
                    $(this).parents('.product_item').find('ul li:first-child').addClass('active');
                    current_pro.removeClass('active');
                  }				
            });

            $('.prv.prev').click(function(e) {
              var current_pro = $(this).parents('.product_item').find('ul li.active');
              var current_index = current_pro.index();

              if(current_index == 0){
                $(this).parents('.product_item').find('ul li:last-child').addClass('active');
                current_pro.removeClass('active');
              }
              else{
                current_pro.prev().addClass('active');
                current_pro.removeClass('active');
              }
            });
        }
	}
	



	//=========================  heapbox dropdown	
	$(".sortby").heapbox();
	
$( function() {
    $( "#accord" ).accordion({
      collapsible: true,
      heightStyle: "content"
    });
  } );